import { BaseEntity, MemoizeGetters, toDate, toEntity, Transform } from "./base";
import { Company } from "./company";
import { UserSlim } from "./user-slim";
import { titleCase } from "../shared/string";

export enum Role {
  Admin = 'admin',
  Driver = 'driver',
  Manager = 'manager',
  Owner = 'owner'
}

@MemoizeGetters
export class Affilation extends BaseEntity {
  @Transform(toEntity(Company))
  company?: Company;

  @Transform(toEntity(UserSlim))
  user?: UserSlim;

  @Transform(toDate)
  claimedAt?: Date;

  role: Role;

  /** What the current user may do to this affiliation, decided by the server. */
  permittedActions?: { update?: boolean };

  get userName() {
    return this.user.name;
  }

  get userEmail() { 
    return this.user.email;
  }

  get userPhone() {
    return this.user.phone;
  }

  get userPhoneFormatted(): string {
    // (123) 456-7890
    return this.user.phone?.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }

  get roleFormatted(): string {
    return titleCase(this.role);
  }

  get claimedStatus(): string {
    return this.claimedAt ? 'Active' : 'Invite Pending';
  }
}

/** Roles absent from this map are never offered in the invite flow. */
export const ROLE_ACCESS_LABELS: Partial<Record<Role, string>> = {
  [Role.Admin]: 'Full Portal Access',
  [Role.Manager]: 'Team & Fleet Access',
  [Role.Driver]: 'Limited Portal Access',
};

export interface CreateAffiliationParams {
  email: string
}
